import { Link } from "react-router-dom";
import { useSession } from "../auth/session";
import { credits } from "../lib/format";
import { useCredits } from "../state/queries";
import { Icon } from "../ui";
import { FolderTree } from "./FolderTree";
import { JobsList } from "./JobsList";

// §11 rechte Region: Credits-Saldo, Folder-Tree und Jobs. Saldo = verfügbares
// Guthaben (Σ lots.remaining + adjustments, §9.10) via /v1/credits. D154: die Inbox-Zeile
// erscheint hier NICHT mehr (nur im Assets-Browser) — ihr Inhalt dupliziert die Jobs-Section.

function CreditsBar() {
  const { status } = useSession();
  const balance = useCredits();
  return (
    <Link
      to="/account"
      className="panel flex shrink-0 items-center justify-between gap-2 p-3 transition-colors hover:border-accent/40"
    >
      <span className="flex items-center gap-2 text-sm text-muted">
        <Icon name="coins" size={18} className="text-accent" />
        Guthaben
      </span>
      <span className="font-mono text-sm font-semibold">
        {status === "signed-in" && balance.data !== undefined ? credits(balance.data) : "—"}
      </span>
    </Link>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  // shrink-0 (D100-Fix): die Sidebar ist eine flex-col mit overflow-y-auto — OHNE shrink-0
  // SCHRUMPFT Flexbox die Sections, sobald Tree+Jobs zusammen höher als die Sidebar sind
  // (min-h-0 hob die min-content-Untergrenze auf), und der Section-Inhalt malt sichtbar
  // ÜBER die nächste Section (Ordner-Buttons überlagerten die Jobs-Liste). Mit shrink-0
  // behalten die Sections ihre Inhaltshöhe und der Sidebar-Container scrollt.
  return (
    <section className="shrink-0">
      <h3 className="px-1 pb-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted">{title}</h3>
      {children}
    </section>
  );
}

export function RightSidebar() {
  return (
    <div className="flex h-full w-full flex-col gap-4 overflow-y-auto p-3">
      <CreditsBar />
      <Section title="Ordner">
        {/* D100: Inhalte INLINE — Ordner sind hier aufklappbar und zeigen ihre Assets
            direkt im Tree (Thumbnails); ein Drop expandiert den Zielordner. D154: keine
            Inbox-Zeile in der Generate-Sidebar (dupliziert die Jobs-Section darunter). */}
        <FolderTree showContents />
      </Section>
      <Section title="Jobs">
        <JobsList />
      </Section>
    </div>
  );
}
